import React from 'react'

function BackTop() {
  return (
    // <!-- Back to Top -->
    <a href="#top" class="btn btn-lg btn-primary btn-lg-square rounded back-to-top"><i class="bi bi-arrow-up"></i></a>
  )
}

export default BackTop